import cx from 'classnames';
import { forwardRef, InputHTMLAttributes, useEffect, useState, ReactNode } from 'react';

import style from './Checkbox.module.css';

type Props = {
    label: string | ReactNode;
    checkboxProps: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
        'data-testid'?: string;
    };
    required?: boolean;
    className?: string;
    error?: string;
};

export const Checkbox = forwardRef<HTMLInputElement, Props>(
    ({ label, checkboxProps, required, className, error }, ref) => {
        const [isChecked, setIsChecked] = useState(checkboxProps.checked);

        useEffect(() => {
            setIsChecked(checkboxProps.checked);
        }, [checkboxProps.checked]);

        return (
            <div>
                <label className={cx(style.label, 'font-xs-regular', className)}>
                    <div className={style.inputWrapper}>
                        <input
                            {...checkboxProps}
                            ref={ref}
                            onChange={(event) => {
                                const isChecked = event.target.checked;

                                if (checkboxProps.onChange) {
                                    checkboxProps.onChange(event);
                                }
                                setIsChecked(isChecked);
                            }}
                            checked={isChecked}
                            type="checkbox"
                        />
                        <div className={style.checkmark} />
                    </div>
                    {label}
                    {required ? <span>*</span> : null}
                </label>
                {error ? (
                    <div className={cx(style.textError, 'font-xs-regular')}>{error}</div>
                ) : null}
            </div>
        );
    },
);
